###
# This source code is licensed under the terms of the
# GNU Affero General Public License found in the LICENSE file in
# the root directory of this source tree.
#
# Copyright (c) 2021-present Kaleidos INC
###

groupBy = @.taiga.groupBy

class HomeService extends taiga.Service
    @.$inject = [
        "$tgNavUrls",
        "tgResources",
        "tgProjectsService",
        "$q"
    ]

    constructor: (@navurls, @rs, @projectsService, @q) ->

    _attachProjectInfoToWorkInProgress: (workInProgress, projectsById) ->
        _attachProjectInfoToDuty = (duty, objType) =>
            project = projectsById.get(String(duty.get('project')))

            ctx = {
                project: project.get('slug')
                ref: duty.get('ref')
            }

            url = @navurls.resolve("project-#{objType}-detail", ctx)

            duty = duty.set('url', url)
            duty = duty.set('project', project)
            duty = duty.set("_name", objType)

            return duty

        _getValidDutiesAndAttachProjectInfo = (duties, dutyType)->
            # Exclude duties where I'm not member of the project
            duties = duties.filter((duty) ->
                return projectsById.get(String(duty.get('project'))))

            duties = duties.map (duty) ->
                return _attachProjectInfoToDuty(duty, dutyType)

            return duties

        assignedTo = workInProgress.get("assignedTo")

        if assignedTo.get("epics")
            _duties = _getValidDutiesAndAttachProjectInfo(assignedTo.get("epics"), "epics")
            assignedTo = assignedTo.set("epics", _duties)

        if assignedTo.get("userStories")
            _duties = _getValidDutiesAndAttachProjectInfo(assignedTo.get("userStories"), "userstories")
            assignedTo = assignedTo.set("userStories", _duties)

        if assignedTo.get("tasks")
            _duties = _getValidDutiesAndAttachProjectInfo(assignedTo.get("tasks"), "tasks")
            assignedTo = assignedTo.set("tasks", _duties)

        if assignedTo.get("issues")
            _duties = _getValidDutiesAndAttachProjectInfo(assignedTo.get("issues"), "issues")
            assignedTo = assignedTo.set("issues", _duties)


        watching = workInProgress.get("watching")

        if watching.get("epics")
            _duties = _getValidDutiesAndAttachProjectInfo(watching.get("epics"), "epics")
            watching = watching.set("epics", _duties)

        if watching.get("userStories")
            _duties = _getValidDutiesAndAttachProjectInfo(watching.get("userStories"), "userstories")
            watching = watching.set("userStories", _duties)

        if watching.get("tasks")
            _duties = _getValidDutiesAndAttachProjectInfo(watching.get("tasks"), "tasks")
            watching = watching.set("tasks", _duties)

        if watching.get("issues")
            _duties = _getValidDutiesAndAttachProjectInfo(watching.get("issues"), "issues")
            watching = watching.set("issues", _duties)

        workInProgress = workInProgress.set("assignedTo", assignedTo)
        workInProgress = workInProgress.set("watching", watching)

    getWorkInProgress: (userId) ->
        projectsById = Immutable.Map()

        projectsPromise = @projectsService.getListProjectsByUserId(userId).then (projects) ->
            projectsById = Immutable.fromJS(groupBy(projects.toJS(), (p) -> p.id))

        assignedTo = Immutable.Map()

        params_epics = {
            status__is_closed: false
            assigned_to: userId
        }

        params_uss = {
            is_closed: false
            assigned_users: userId
            dashboard: true
        }

        params_tasks = {
            status__is_closed: false
            assigned_to: userId
        }

        params_issues = {
            status__is_closed: false
            assigned_to: userId
        }

        assignedEpicsPromise = @rs.epics.listInAllProjects(params_epics).then (epics) ->
            assignedTo = assignedTo.set("epics", epics)

        assignedUserStoriesPromise = @rs.userstories.listInAllProjects(params_uss).then (userstories) ->
            assignedTo = assignedTo.set("userStories", userstories)

        assignedTasksPromise = @rs.tasks.listInAllProjects(params_tasks).then (tasks) ->
            assignedTo = assignedTo.set("tasks", tasks)

        assignedIssuesPromise = @rs.issues.listInAllProjects(params_issues).then (issues) ->
            assignedTo = assignedTo.set("issues", issues)

        params_epics = {
            status__is_closed: false
            watchers: userId
        }

        params_uss = {
            is_closed: false
            watchers: userId
            dashboard: true
        }

        params_tasks = {
            status__is_closed: false
            watchers: userId
        }

        params_issues = {
            status__is_closed: false
            watchers: userId
        }

        watching = Immutable.Map()

        watchingEpicsPromise = @rs.epics.listInAllProjects(params_epics).then (epics) ->
            watching = watching.set("epics", epics)

        watchingUserStoriesPromise = @rs.userstories.listInAllProjects(params_uss).then (userstories) ->
            watching = watching.set("userStories", userstories)

        watchingTasksPromise = @rs.tasks.listInAllProjects(params_tasks).then (tasks) ->
            watching = watching.set("tasks", tasks)

        watchingIssuesPromise = @rs.issues.listInAllProjects(params_issues).then (issues) ->
            watching = watching.set("issues", issues)

        workInProgress = Immutable.Map()

        return @q.all([
            projectsPromise,
            assignedEpicsPromise,
            watchingEpicsPromise,
            assignedUserStoriesPromise,
            watchingUserStoriesPromise,
            assignedTasksPromise,
            watchingTasksPromise,
            assignedIssuesPromise,
            watchingIssuesPromise
        ]).then =>
            workInProgress = workInProgress.set("assignedTo", assignedTo)
            workInProgress = workInProgress.set("watching", watching)

            workInProgress = @._attachProjectInfoToWorkInProgress(workInProgress, projectsById)

            return workInProgress

angular.module("taigaHome").service("tgHomeService", HomeService)
